import { IPaginationReturn } from '../../interfaces/IPaginationReturn';
import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IWorkstation from '../../interfaces/IWorkstation';

export interface IFilterWorkstation {
  id?: number | null;
}

const useWorkstationService = () => {
  const Subsidiary = useRequest<IWorkstation>();
  const path = 'employee/workstation';

  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    direction: 'asc' | 'desc',
    filter?: IFilterWorkstation,
  ): Promise<IPaginationReturn<IWorkstation[]>> => {
    return await Subsidiary.postAndGetManyPaginated({
      path: `${path}/list?perPage=${perPage}&currentPage=${currentPage}&orderBy=${orderField}&orderDirection=${direction}`,
      sendAuthorization: true,
      body: { ...filter },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const findById = async (id: number): Promise<IWorkstation> => {
    return await Subsidiary.getOne({
      path: `${path}/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listWorkstationByName = async (name: string): Promise<IWorkstation[]> => {
    return await Subsidiary.getMany({
      path: `${path}/findByName/${name}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listWorkstationSearch = async (filter: string): Promise<IWorkstation[]> => {
    if (filter === '') {
      filter = ' ';
    }

    const url = filter
      ? `${path}/search?perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter=${filter}`
      : `${path}/search?perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter= `;

    return await Subsidiary.getManyPaginated({
      path: url,
      sendAuthorization: true,
    })
      .then(result => {
        return result?.data;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listWorkstationBySubsidiaryId = async (id: number): Promise<IWorkstation[]> => {
    return await Subsidiary.getMany({
      path: `${path}/ListBySubsidiaryId/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async ({ code, name }: IWorkstation): Promise<IWorkstation> => {
    return await Subsidiary.post({
      path: `${path}`,
      sendAuthorization: true,
      body: { code, name },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: number, { code, name }: IWorkstation): Promise<IWorkstation> => {
    return await Subsidiary.put({
      path: `${path}/${id}`,
      sendAuthorization: true,
      body: { code, name },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: number): Promise<void> => {
    return await Subsidiary.remove({
      path: `${path}/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return {
    list,
    listWorkstationByName,
    findById,
    listWorkstationSearch,
    listWorkstationBySubsidiaryId,
    create,
    update,
    remove,
  };
};

export { useWorkstationService };
